export async function hasTextInPDF(pdfData: File) {
	const arrayBuffer = await pdfData.arrayBuffer()
	try {
		const uint8Array = new Uint8Array(arrayBuffer)
		const str = new TextDecoder('ascii').decode(uint8Array)
		const hasText = /\/Font|\/Text|BT\/ET|Tj|TJ/.test(str)
		return hasText
	} catch (error) {
		console.error('Ошибка при проверке PDF:', error)
		return false
	}
}
